import React, {  Component } from 'react'
import ReactDOM from 'react-dom/client';
import avtlogo from "./img/avt.png"; 
import Apprt from './App.js';
//import AdmDashboard from './components/AdminDashboard.js';
import './assets/css/homestyle.css'
import axios from 'axios';
import { removeUserSession, setUserSession,aPIURL,auTHURL } from './utils/common.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CDashboard from './components/ClientApplication/CDashboard.js';
import Modal from './components/LoginModal.js';
import PriceList from './components/PriceList.js';
import PublicNav from './Shared/PublicNav.js'
import PublicFooter from './Shared/PublicFooter.js'
import $ from 'jquery';
import bvideo from './img/AVT-banner.mp4';
import Blogdt from './gps-tracking-device.js';

class Blog extends React.Component 
{
  
  
  constructor(props) 
  {
    
    super(props);
    
     
  }
  
  showBlogdt=()=>
    {
      const root = ReactDOM.createRoot(document.getElementById('root'));
      root.render(<Blogdt/>);
    }
 

  render() 
  {
   
    
     return (
      <>       

<header id="header" class="">
  <div class="container d-flex align-items-center header-center justify-content-between"> 
  <a href="index.html" class="logo"> <img src="../img/avt.png" alt="AVT" class="img-fluid"/> </a>

  

  <ul class="navbar-nav avt-top-menu collapse" id='topMenu'>
        <li class="nav-item"> <a href="index.html">Home</a> </li>
        <li class="nav-item"> <a href="index.html">Pricing</a> </li>
        <li class="nav-item"> <a href="index.html">Contact</a> </li>
        
      </ul>
    <div class="logo-right-list">
    
    <span></span>
    <span></span>
    <span></span>
    
    <span></span>
    </div>
  </div>
</header>
<section class="pricing topsection">
  <div class="container"> 
  <div class="row"><div class="col-lg-5">
  <h1></h1>
   
    </div></div>
  </div>
</section>
<section class="blog-banner">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-6">
        <div class="bannerContent">
          <h1 class="bannerHeader">AVT Blog</h1>
        </div>
      </div>
      <div class="col-6"> <img src="../img/blog-banner-1.svg" alt="Blogs" style= {{ margin:"auto", "maxWidth":"400px"}}/> </div>
    </div>
  </div>
</section>
<section class="blog inner pt-60 pb-60">
  <div class="container">
    <div class="row">
      <div class="col-lg-8">
        
        <div class="blogWrapper shadow">
          <div class="blogImg"> <a href="#" onClick={this.showBlogdt}>  <img src="../img/avt-blog.jpg" alt="GPS Tracking Devices: Used for Safety and Efficiency"/> </a> </div>
          <div class="blogText"> <a href="#" onClick={this.showBlogdt}>GPS Tracking Devices: Used for Safety and Efficiency</a>
            <ul class="blogDateTime">
              <li><i class="far fa-calendar-alt" aria-hidden="true"></i>Sep 10, 2024</li>
            </ul>
            <p>The fast growth of the transportation industry and vehicles in the country makes it very challenging to manage the management of the transportation industry therefore GPS tracking is one of the best ways to get rid of finding their real-time to know the actual location of vehicles. GPS tracking device is one of the best ways to find and track real-time information about the movement of vehicles and assets. GPS tracking devices communicate with satellites orbiting through the earth, they transmit the receiver and allow them to communicate through the location.</p>
          </div>
        </div>
        
        <div id="pagination-container"></div>
      </div>
      <div class="col-lg-4 md-mb-50 pl-35 lg-pl-15 md-order-first">
		  
        <div class="sidebar shadow">
          <div class="sidebar-title">
            <h3 class="title">Recent Post</h3>
          </div>
          <div class="sidebar-block">
            <div class="sidebar-block-image"> <a href="gps-tracking-device.html"> <img src="../img/avt-blog.jpg" alt="GPS Tracking Devices: Used for Safety and Efficiency"/> </a> </div>
            <div class="sidebar-block-text"> <a href="gps-tracking-device.html">GPS Tracking Devices: Used for Safety and Efficiency </a>
              <ul class="blogDateTime m-0">
                <li><i class="far fa-calendar-alt" aria-hidden="true"></i> 13 September, 2024</li>
              </ul>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</section>






<PublicFooter/>

            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>
    </>
      
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Blog/>);


export default Blog;